import icon from 'vue-svgicon';

icon.register({
    'regular/following-1': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M9.43221 10.5705c2.60589 0 4.71839 -2.11245 4.71839 -4.71834 0 -2.60588 -2.1125 -4.71837 -4.71839 -4.71837 -2.60589 0 -4.71837 2.11249 -4.71837 4.71837 0 2.60589 2.11248 4.71834 4.71837 4.71834Z" stroke-width="1.5"></path><path pid="1" d="M1.04785 19.8469c1.09576 -3.5901 4.48935 -6.2817 8.38762 -6.2817 2.45473 0 4.70933 1.0673 6.31613 2.7541" stroke-width="1.5"></path><path pid="2" d="m12.9229 19.4326 10.0292 0" stroke-width="1.5"></path><path pid="3" d="m19.5186 15.9971 3.4342 3.4342 -3.4342 3.4342" stroke-width="1.5"></path>`,
    },
});
